import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ctrl",
  "use": "ctrl-usage",
  "viewBox": "0 0 18.13 20",
  "content": "<symbol viewBox=\"0 0 18.13 20\" id=\"ctrl\"><title>ctrl</title><path d=\"M5.31,9V.58a.63.63,0,0,0-1.25,0V9a3.75,3.75,0,0,0,0,7.39v3a.63.63,0,0,0,1.25,0v-3A3.75,3.75,0,0,0,5.31,9Zm-.62,6.19a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,4.69,15.16Z\" transform=\"translate(-0.94)\" /><path d=\"M19.06,7.34a3.75,3.75,0,0,0-3.12-3.69v-3a.63.63,0,0,0-1.25,0v3a3.75,3.75,0,0,0,0,7.39v8.39a.63.63,0,0,0,1.25,0V11A3.75,3.75,0,0,0,19.06,7.34Zm-3.75,2.5a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,15.31,9.84Z\" transform=\"translate(-0.94)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/ctrl.svg
// module id = NCJS
// module chunks = 264